import { useInstancesByQuery } from 'hive-react-utils';
import _ from 'lodash';
import { useMemo } from 'react';
const formatPatient = (cliniciansById) => (p) => (Object.assign(Object.assign({}, p), { properties: Object.assign(Object.assign({}, p.properties), { name: _.join(_.compact([p.properties.lastname, p.properties.firstname]), ', '), clinician: _.get(cliniciansById, p.properties.clinicianID) }) }));
export function usePatients(cliniciansById) {
    const rawPatients = useInstancesByQuery('ecarepd', 'activePatients', 'patient', {});
    return useMemo(() => _.map(rawPatients, formatPatient(cliniciansById)), [rawPatients, cliniciansById]);
}
